// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"179":"848479e8","440":"46224c2f","956":"64a57296"}[chunkId] + ".chunk.css";
};